/*
 * @Author: cc
 * @Date: 2020-09-01 15:38:14
 * @LastEditTime: 2021-07-07 09:59:44
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\website\website.js
 * @Description: 
 */
'use strict';
angular.module('editingCenterWebsiteModule', [
    'websiteLeftServiceModule',
    'websiteLeftModule',
    'editingCenterWebsiteRouterModule',
    'websiteAllModule',
    'websitetoBeCompiledModule',
    'websitePendingModule',
    'websiteSignedModule',
    'websiteToBeCompiledNewsModule',
    'websiteServiceModule',
    'websiteFragmentManagementModule',
    'websitePreviewRouterModule',
    'websiteBtnServiceModule',
    'getWebsiteNameModule',
    'websiteSignedVisualizeModule',
    'websiteMlfCloudModule',
    'leftToolTipModule',
]).value('websiteConst', {
    listenStroageKey: 'Website', // 监听缓存的名称
    draftTypeToNum: { // 稿件类型对应数字
        news: '1',
        atlas: '2',
        subject: '3',
        linkDoc: '4',
        video: '7',
    },
    detailMethodname: {
        1: 'getNewsDoc',
        2: 'getPicsDoc',
        3: 'getSpecialDoc',
        4: 'getLinkDoc',
    },
    trial: {
        // 送审参数
        serviceid: 'mlf_websiteoper',
        methodname: 'trialMetaDatas',
    },
    trialParams: {
        serviceid: 'mlf_websiteoper',
        methodname: 'trialMetaDatas',
    },
    rejection: {
        serviceid: 'mlf_websiteoper',
        methodname: 'rejectionMetaDatas',
    },
    delete: {
        serviceid: 'mlf_websiteoper',
        methodname: 'trashMetaDatas',
    },
    daibianSign: {
        serviceid: 'mlf_websiteoper',
        methodname: 'webDaiBianPublish',
    },
    daibianTimeSign: {
        serviceid: 'mlf_websiteoper',
        methodname: 'webDaiBianTimingPublish',
    },
    daishenSign: {
        serviceid: 'mlf_websiteoper',
        methodname: 'webDaiShenPublish',
    },
    daishenTimeSign: {
        serviceid: 'mlf_websiteoper',
        methodname: 'webDaiShenTimingPublish',
    },
    changeTimeSing: {
        serviceid: 'mlf_websiteoper',
        methodname: 'webChangeTimingPublish',
    },
    draftListDB: {
        // 待编发稿单参数
        serviceid: 'mlf_appfgd',
        methodname: 'webDaiBianbatchUpdateFgdUsers',
    },
    draftListDS: {
        // 待审发稿单参数
        serviceid: 'mlf_appfgd',
        methodname: 'webDaiShenbatchUpdateFgdUsers',
    },
    draftListQuery: {
        // 发稿单查询参数
        serviceid: 'mlf_appfgd',
        methodname: 'queryFgdByMetaDataId',
    },
    withdrawrejection: {
        serviceid: 'mlf_websiteoper',
        methodname: 'withdraw',
    },
    collectDS: {
        serviceid: 'mlf_websiteoper',
        methodname: 'collectionDAISHENDocs',
    },
    collectDB: {
        serviceid: 'mlf_websiteoper',
        methodname: 'collectionDAIBIANDocs',
    },
    collectYQF: {
        serviceid: 'mlf_websiteoper',
        methodname: 'collectionYIQIANFADocs',
    },
    reviseDB: {
        serviceid: 'mlf_modifydoc',
        methodname: 'appointDocToUserOfWebDaiBian',
    },
    reviseDS: {
        serviceid: 'mlf_modifydoc',
        methodname: 'appointDocToUserOfWebDaiShen',
    }, 
    outSendDB: {
        serviceid: 'mlf_mailoutgoingOper',
        methodname: 'webDaiBianSendEmail',
    },
    outSendDS: {
        serviceid: 'mlf_mailoutgoingOper',
        methodname: 'webDaiShenSendEmail',
    },
    outSendYQF: {
        serviceid: 'mlf_mailoutgoingOper',
        methodname: 'webYiQianFaSendEmail',
    }

});
